import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EventFamily extends RestResource {
  symbol = ""
  description = ""
}

export const EVENT_FAMILY_DESER: SchemaDeSer<EventFamily> =
  new SchemaDeSerBuilder(EventFamily)
    .ofString("id")
    .ofString("symbol")
    .ofString("description")
    .toDeSer()
